import React, {useState, useEffect} from 'react'
import {httpGet, httpPost} from '../shared/Config';
import {Button, FormGroup, Label, Input, } from 'reactstrap';
import ConfirmationModal from '../shared/ConfirmationModal';
import SimpleModal from "../shared/SimpleModal";
import { useTranslation } from 'react-i18next';

function SubscribeModal({isOpen, onCancel, subscriptionType, askFacturacion, existingSubscription, tenant, onComplete, title}) {
    
    const {t} = useTranslation();

    const [buyState, setBuyState] = useState({
        subscriptionType: subscriptionType,
        paymentType: 'Stripe',
        mode: 'monthly'
    });

    const [showConfModal, setShowConfModal] = useState(false);
    const [subTypeFormat, setSubTypeFormat] = useState('Sharepoint');
    const [processingPayment, setProcessingPayment] = useState(false);
    const [working, setWorking] = useState(false);
    const [error, setError] = useState("");

    const [priceInfo, setPriceInfo] = useState({});
    const [priceFetch, setPriceFetch] = useState(false);

    useEffect(() => {
        async function fetchSubscriptionPriceInfo() {
            try {
                const subscritionFetch = await httpGet(`/subscription/${subscriptionType}/getPriceInfo`);
                if(subscritionFetch.data) {
                    if(subscritionFetch.data) {
                        setPriceInfo(subscritionFetch.data);
                    } else if(subscritionFetch.data.error) {
                        console.log(subscritionFetch.data.error);
                    }
                } else {
                    // no subscription found for this type
                }
                setPriceFetch(true);
            } catch(e) {
                console.log(e);
            }
        }

        fetchSubscriptionPriceInfo();
    }, []);

    function handleClick(attr) {
        return function(event) {
            setBuyState({...buyState, [attr]:event.target.value})
        }
    }

    function subscribeConfirmation(e) {
        e.preventDefault();
        e.stopPropagation();
        setShowConfModal(true);
    }

    function handleCancel() {
        onCancel();
    }

    function handleConfCancel() {
        setShowConfModal(false);
    }

    function handlePurchaseClick() {
        if (showConfModal) {
            setProcessingPayment(true);
        }
    }

    useEffect(() => {
        async function processPayment() {
            if(buyState.paymentType.includes("Stripe")) {
                const response = await httpPost(`/subscription/intentStripePaySubscription`, {buyState})
                if (response.data.error) {
                    if(response.data.error === "subscription_exists") {
                        window.location.reload();
                    } else {
                        setError(response.data.error);
                    }
                } else if(response.data.checkoutUrl) {
                    window.location.href = response.data.checkoutUrl;
                }
            } else {
                /*try {
                    const response = await httpPost(`/subscription/suscribeExternalStorage`, {
                        buyState
                    })
                    const {success, error} = response.data;
                    if (success) {
                        //setNoticeModal({...noticeModal, open: true});
                    } else {
                        console.log(error);
                    }
                    setWorking(false);
                    setProcessingPayment(false);
                    setShowConfModal(false);
                    onComplete();
                } catch (e) {
                    setWorking(false);
                    setProcessingPayment(false);
                    setShowConfModal(false);
                    onCancel();
                }*/
            }
        }

        if (processingPayment) {
            processPayment();
        }
    }, [processingPayment])

    function handlePaymentTypeChange(value) {
        setBuyState({...buyState, paymentType: value});
     }


    return (
        <SimpleModal isOpen={isOpen}>
            <form onSubmit={subscribeConfirmation}>
                <h3>
                    {t(title)}
                </h3>
                <div>
                    <div>
                        {
                            priceFetch ? <React.Fragment>
                            <p>
                                {/*Costo mensual por SPEI: ${priceInfo.speiExternalStorageMonthly}
                                <br/>
                                Costo anual por SPEI: ${priceInfo.speiExternalStorageYearly}
                                 <br/>*/}
                                {t('MONTHLY_COST')}: ${priceInfo.stripeExternalStorageMonthly}
                                <br/>
                                {t('YEARLY_COST')}: ${priceInfo.stripeExternalStorageYearly}
                                <br/>
                                {
                                    subscriptionType === "PERSONAL_2024" || subscriptionType === "TEAMS_2024" ? <React.Fragment>
                                        {t('YOU_ARE_ABOUT_TO_START_A_SUBSCRIPTION')} {t(subscriptionType)}
                                    </React.Fragment> : <React.Fragment>
                                        {t('ONLY_ONE_SUBSCRIPTION_OF_THIS_TYPE')}
                                    </React.Fragment>
                                }
                                <br/>
                            </p>
                            </React.Fragment> : <React.Fragment>
                                {t('LOADING_PRICES')}
                                <br/>
                                <br/>
                            </React.Fragment>
                        }
                    </div>
                    <div>{t('SELECT_PAYMENT_PLAN')}</div>
                    <FormGroup style={{marginLeft: '5%', marginTop: '2%', marginBottom: '1%'}} check>
                        <Input name="radio3" type="radio" value="monthly" checked={"monthly" === buyState.mode} onChange={handleClick('mode')} />{' '}
                        <Label check>
                            {t('MONTHLY')}
                        </Label>
                    </FormGroup>
                    <FormGroup style={{marginLeft: '5%', marginTop: '2%', marginBottom: '1%'}} check>
                        <Input name="radio3" type="radio" value="yearly" checked={"yearly" === buyState.mode} onChange={handleClick('mode')} />{' '}
                        <Label check>
                            {t('ANNUALY')}
                        </Label>
                    </FormGroup>
                    <br/>
                    {/*<div>
                        <SelectPaymentType value={buyState.paymentType} subValue={buyState.sub} action="SUB" type="documentos" onChange={handlePaymentTypeChange} pendingPayments={pendingPayments} askFacturacion={askFacturacion} paymentMethods={tenant.paymentMethods} shoppingCart={false} />
                    </div>*/}
                </div>
                <div className={'modal-action'}>
                    <Button disabled={!priceFetch} type="submit" color="primary">{t('PROCEED_TO_PAYMENT')}</Button>
                    <Button color="secondary" onClick={handleCancel}>{t('CANCEL')}</Button>
                </div>
            </form>
            <ConfirmationModal isOpen={showConfModal}
                onCancel={handleConfCancel}
                onOk={handlePurchaseClick}
                title="SUBSCRIPTION_CONFIRMATION">
                    <span>{t('SUBSCRIPTION_INFO_1')} {t(subscriptionType)}</span>
                    <br/><br/>
                    <span>{t('MODE')}:</span>
                    {
                        buyState.mode === "monthly" ? <div><b>{t('MONTHLY')}</b></div> : null
                    }                    
                    {
                        buyState.mode === "yearly" ? <div><b>{t('ANNUALY')}</b></div> : null
                    }
                    {/*<span>Metodo de compra</span>
                    <br/> <span style={{ textTransform: 'uppercase', fontWeight: 'bold'}}>{buyState.paymentType}</span>
                <br/>*/}
                    <p>{t('CONTINUE_QUESTION')}</p>
            </ConfirmationModal>
        </SimpleModal>
    )
}

export default SubscribeModal;
